import { csosUpmApi, IError, ResponseCSOSHeaders } from '..';
import { pathOr } from 'rambda';
import { left, right } from 'fp-ts/lib/Either';
import { flow } from 'fp-ts/function';

export const searchCsaRequest =
  (hR: ResponseCSOSHeaders) =>
  ({
    page,
    pageSize,
    sortBy,
    sortDirection,
    searchBy,
    searchP1,
    searchP2,
  }: {
    page: number;
    pageSize: number;
    sortBy: string;
    sortDirection: string;
    searchBy: string;
    searchP1: string;
    searchP2: string;
  }) =>
    csosUpmApi(hR)
      .get(
        `v1/api/admin/csadata-search?${getsearchBy({
          searchBy,
          searchP1,
          searchP2,
        })}page=${page}&sizePerPage=${pageSize}&orderBy=${sortBy}&orderDirection=${sortDirection.toUpperCase()}${createdAt(
          { searchBy, searchP1, searchP2 }
        )}${updateDatetime({ searchBy, searchP1, searchP2 })}${deaRetdt({
          searchBy,
          searchP1,
          searchP2,
        })}`
      )
      .then(flow(pathOr({ totalElements: 0, content: [] }, 'data'), right))
      .catch(e => left(e as IError));

const createdAt = ({
  searchBy,
  searchP1,
  searchP2,
}: {
  searchBy: string;
  searchP1: string;
  searchP2: string;
}) =>
  searchBy === 'createdAt'
    ? `&afterCreatedAtDate=${searchP1}&beforeCreatedAtDate=${searchP2}`
    : `&afterCreatedAtDate=1922-03-21&beforeCreatedAtDate=2032-07-21`;

const updateDatetime = ({
  searchBy,
  searchP1,
  searchP2,
}: {
  searchBy: string;
  searchP1: string;
  searchP2: string;
}) =>
  searchBy === 'updateDatetime'
    ? `&afterUpdateDatetime=${searchP1}&beforeUpdateDatetime=${searchP2}`
    : `&afterUpdateDatetime=1922-03-21&beforeUpdateDatetime=2032-07-21`;

const deaRetdt = ({
  searchBy,
  searchP1,
  searchP2,
}: {
  searchBy: string;
  searchP1: string;
  searchP2: string;
}) =>
  searchBy === 'deaRetdt'
    ? `&afterDeaRetdt=${searchP1}&beforeDeaRetdt=${searchP2}`
    : `&afterDeaRetdt=1922-03-21&beforeDeaRetdt=2032-07-21`;

const getsearchBy = ({
  searchBy,
  searchP1,
  searchP2,
}: {
  searchBy: string;
  searchP1: string;
  searchP2: string;
}) =>
  searchBy === 'createdAt' ||
  searchBy === 'updateDatetime' ||
  searchBy === 'deaRetdt'
    ? ``
    : `${searchBy}=${searchP1}&`;
